var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStartProduct(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 9.675,
    height: 11.882,
    viewBox: "0 0 9.675 11.882",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "play",
    d: "M11.662,3.946,6.938.48A2.476,2.476,0,0,0,3,2.477V9.408a2.476,2.476,0,0,0,3.94,2l4.723-3.466a2.476,2.476,0,0,0,0-3.993ZM11.075,7.14,6.352,10.606a1.485,1.485,0,0,1-2.362-1.2V2.477A1.46,1.46,0,0,1,4.8,1.154,1.494,1.494,0,0,1,5.479.991a1.471,1.471,0,0,1,.873.292l4.723,3.466a1.485,1.485,0,0,1,0,2.394Z",
    fill: "#35C385",
    transform: "translate(-3 -0.002)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStartProduct);
export default __webpack_public_path__ + "static/media/startProduct.a488b3af500928bd6eb3c04b8c6dcf13.svg";
export { ForwardRef as ReactComponent };